const MILLISECONDS_PER_DAY = 86400000;

export const getWorkshopRegistrationDeadlineDays = () => {
  const configuredDays = Number(process.env.REACT_APP_WS_REG_DEADLINE_DAYS);
  return Number.isFinite(configuredDays) && configuredDays >= 0 ? configuredDays : 1;
};

export const getWorkshopRegistrationDeadline = (startDate) =>
  new Date(new Date(startDate).getTime() - getWorkshopRegistrationDeadlineDays() * MILLISECONDS_PER_DAY);

export const isWorkshopRegistrationPastDeadline = (startDate, now = new Date()) =>
  getWorkshopRegistrationDeadline(startDate) < now;

export const getUpcomingWorkshopStartDate = (now = new Date()) =>
  new Date(now.getTime() + getWorkshopRegistrationDeadlineDays() * MILLISECONDS_PER_DAY);
